import './OkulSubeleriPage.scss'

import { DeleteOutlined } from '@ant-design/icons'
import { Button, Modal, notification, Table } from 'antd'
import DeleteModal from 'components/okulyonetim-admin/delete-modal/DeleteModal'
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import AppContext from '../../../../context/AppContext'
import { useKampusSilMutation, useOkulKampusleriQuery } from '../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../spinner/Spinner'

const OkulSubeleriPage: React.FC = () => {
  const navigate = useNavigate()
  const { okul } = useContext(AppContext)
  const { data, loading, error, refetch } = useOkulKampusleriQuery({
    // <-- refetch ekledik
    variables: {
      sube_id: okul?.id,
    },
    fetchPolicy: 'network-only',
  })
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)
  const [deleteId, setDeleteId] = useState<string | null>(null)
  const [modalMessage, setModalMessage] = useState<string[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [kampusSilMutation] = useKampusSilMutation()
  const showDeleteModal = (ids: string[]) => {
    setDeleteId(ids.join(','))
    setIsDeleteModalVisible(true)
  }

  const handleDelete = async (ids: string) => {
    setSubmitting(true)
    const idList: number[] = ids.split(',').map((id) => Number(id))
    try {
      const response = await kampusSilMutation({
        variables: {
          id: idList,
        },
      })
      if (response.data?.kampusSil.success) {
        notification.success({
          message: '',
          description: `${response.data?.kampusSil?.message}`,
          duration: 6,
        })
        setIsDeleteModalVisible(false)
        setSelectedRowKeys([])

        await refetch()
      } else {
        setModalTitle(response.data?.kampusSil.message ?? 'Bir hata oluştu.')
        setIsModalOpen(true)
        const yetkililer = response.data?.kampusSil?.yetkililer?.flatMap((yetkili) => yetkili?.yetkililer) ?? [
          'Bir hata oluştu.',
        ]
        setModalMessage(yetkililer.filter((yetkili): yetkili is string => yetkili !== undefined))
      }
    } catch (error) {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    } finally {
      setSubmitting(false)
    }
  }

  if (loading) {
    return <Spinner showSpinner={loading} color="red" />
  }
  if (submitting) {
    return <Spinner showSpinner={submitting} color="red" />
  }
  if (error) {
    console.error(error)
    navigate('/')
    return null
  }
  // const handleOk = () => {
  //   setIsModalOpen(false)
  // }

  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const filteredData = data?.okulKampusleri?.kampusler?.filter(Boolean) ?? []
  const totalItems = filteredData.length;
  const displayedItems = selectedRowKeys.length;
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' , sorter: (a: any, b: any) => a.id - b.id, defaultSortOrder: 'descend' as 'descend' | 'ascend' | undefined, },
    { title: 'Okul', dataIndex: 'okul', key: 'okul' },
    { title: 'İsim', dataIndex: 'isim', key: 'isim' },
    {
      title: '',
      dataIndex: 'detay',
      key: 'detay',
      render: (_: string, record: any) => (
        <Button
          className="okul-yonetim-admin-detail-button"
          onClick={() => navigate(`/okulyonetimadmin/sube/${record.id}`)}
        >
          Detay
        </Button>
      ),
    },
  ]

  return (
    <div className="okul-siparis-page">
      <div className="okul-sepeti-admin-header">
        <h1>Kampüsler </h1>
        <div className="button-right">
          <Button onClick={() => navigate('/okulyonetimadmin/sube/kampüs-ekle')}>Kampüs Ekle</Button>
        </div>
      </div>
      <Table
        dataSource={filteredData as object[]}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          total: totalItems,
          showTotal: (total) => (
              <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                <Button
                    style={{
                      display: selectedRowKeys.length === 0 ? 'none' : '',
                    }}
                    icon={<DeleteOutlined/>}
                    onClick={() => showDeleteModal(selectedRowKeys.map((id) => id.toString()))}
                    type="primary"
                    danger
                >
                  Seçilen {selectedRowKeys.length} Kampusleri Sil
                </Button>

                <span style={{marginLeft: '10px'}}> {/* Buton ile metin arasına boşluk koyuyoruz */}
                  Seçilen: {displayedItems} / Toplam: {total}
               </span>
              </div>
          ),
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
        loading={loading}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
        rowKey="id"
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys,
          onChange: (keys) => setSelectedRowKeys(keys as string[]),
          ...Selection,
        }}
        className="okul-yonetim-admin-table"
      />
      <DeleteModal
        title="Seçilen Kampüsleri Sil"
        id={deleteId || ''}
        visible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onDelete={handleDelete}
      />
      <Modal
          onCancel={handleCancel}
          footer={<Button onClick={handleCancel}>Kapat</Button>}
          title={modalTitle}
          open={isModalOpen}
      >
        <ul>
          {modalMessage.map((message, index) => {
            const match = message.match(/id=(\d+), isim=([^\}]+)\}/);

            if (match) {
              const id = match[1];
              const name = match[2];

              return (
                  <li key={index}>
                    <a onClick={() => navigate(`/okulyonetimadmin/subeyetkilisi/${id}`)}
                       style={{cursor: 'pointer', color: '#1677ff'}}>
                      {name}
                    </a>
                  </li>
              );
            }

            return <li key={index}>{message}</li>; // fallback
          })}
        </ul>
      </Modal>

    </div>
  )
}

export default OkulSubeleriPage
